import { createRouter } from '@tanstack/react-router';

import i18n from '@repo/i18n';
import { IdentifyError } from '@repo/ui/components/errors/identify-error.tsx';
import { NotFound } from '@repo/ui/components/errors/not-found.tsx';

import { routeTree } from './routeTree.gen.ts';

export const router = createRouter({
  routeTree,
  context: {
    i18n,
    // @ts-expect-error will be implemented in InnerApp
    clerk: undefined,
  },
  defaultNotFoundComponent: NotFound,
  defaultErrorComponent: IdentifyError,
});
